

import { useEffect, useState } from 'react';

import { Toaster } from "components";

import ic_email from 'assets/images/ic_send_email.svg';
import ic_export from 'assets/images/ic_export.svg';
import ic_delete_invoices from 'assets/images/ic_delete_invoices.svg';
import ic_send_to_internal from 'assets/images/ic_send_to_internal.svg';

import { func_validation, func_file } from 'functions';



export function usePendingInvoices(props) {
    const { 
        selectedInvoices,
        invoiceList
    } = props;
    
    // States
    const [isExportingFile, setIsExportingFile] = useState(false);

    function sendMail(isSentToCustomers) {
        if (func_validation.isArrayNotEmpty(selectedInvoices)) {

            if (func_validation.isFunction(props.setAlertMsg)) 
                props.setAlertMsg([]);

            selectedInvoices.map((invoiceDetails, idx) => { 
                let invoiceId = func_validation.getObjectPropertyValue(invoiceDetails, "Id");

                if (func_validation.isNumberValid(invoiceId) &&
                    func_validation.isFunction(props.sendEmail)) {

                    props.sendEmail(invoiceId, isSentToCustomers);
                }
            });
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 invoice.",
            });
        }
    }

    function exportInvoices() {
        setIsExportingFile(true);
        
        if (props.getPendingInvoices)
            props.getPendingInvoices(null, 0);
    }
    function downloadInvoices() {
        if (func_validation.isArrayNotEmpty(invoiceList) &&
            isExportingFile) {

            // Set Header Names
            let headers = [
                "InvoiceId",
                "ReferenceDocumentNo",
                "AccountCode",
                "IssueDateTime",
                "DocumentDateTime",
                "LastSendEmail",
                "SubTotal",
                "InvoiceRemark",
            ];

            // Set rows data
            let rows = invoiceList.map((rowDetail) => {
                let invoiceId = func_validation.getObjectPropertyValue_validNumber(rowDetail, "Id");
                let accountCode = func_validation.getObjectPropertyValue_stringTrimNotEmpty(rowDetail, "AccountCode");
                let issueDateTime = func_validation.getObjectPropertyValue_stringToDateTime(rowDetail, "IssueDateTime");
                let documentDateTime = func_validation.getObjectPropertyValue_stringToDateTime(rowDetail, "DocumentDateTime");
                let InvoiceRemark = func_validation.getObjectPropertyValue_stringTrimNotEmpty(rowDetail, "InvoiceRemark");
                let referenceDocumentNo = func_validation.getObjectPropertyValue_validNumber(rowDetail, "ReferenceDocumentNo");
                let subTotal = func_validation.getObjectPropertyValue_validNumber(rowDetail, "SubTotal");
                let lastSendEmail = func_validation.getObjectPropertyValue_stringToDateTime(rowDetail, "LastSendEmail");


                return {
                    "InvoiceId": invoiceId,
                    "AccountCode": accountCode,
                    "IssueDateTime": issueDateTime,
                    "DocumentDateTime": documentDateTime,
                    "InvoiceRemark": InvoiceRemark,
                    "ReferenceDocumentNo": referenceDocumentNo,
                    "SubTotal": subTotal,
                    "LastSendEmail": lastSendEmail
                }
            });

            func_file.generateFile_XLSX(rows, headers, "Pending Invoices", "Invoices");
            setIsExportingFile(false);
        }
    }
    useEffect(() => {
        downloadInvoices();
    }, [invoiceList]);

    let tableActions = [
        {
            icon: ic_send_to_internal,
            label: "Send to Internal",
            onClick: () => { sendMail(false); },
        },
        {
            icon: ic_delete_invoices,
            label: "Delete",
            isDisabled: func_validation.isUserAccessDenied(props, "Internal_ProformaInvoice_Delete"),
            onClick: () => { 
                if (func_validation.isArrayNotEmpty(selectedInvoices)) {
                    if (func_validation.isFunction(props.setIsModalVisible_deleteInvoice))
                        props.setIsModalVisible_deleteInvoice(true);
                }
                else {
                    Toaster({
                        type: "info",
                        msg: "Please select at least 1 invoice.",
                    });
                }
            },
        },
        // {
        //     icon: ic_export,
        //     label: "Export",
        //     onClick: exportInvoices,
        // },
    ];

    let filters = {
        postStatus: "pending",
        lastSendMail: "unsent",
        advancePayStatus: "normal",
    }
    let tabDetails = {
        id: "pending",
        text: "Pending",
        filters
    };

    let mainTableActionDetails = {
        onClick: () => sendMail(true),
        isDisabled: func_validation.isUserAccessDenied(props, "Internal_ProformaInvoice_Send"),
        icon: ic_email,
        alt: "Mail Icon"
    };

    return {
        isExportingFile,
        tableActions,
        mainTableActionDetails,
        tabDetails,
        filters
    }
}